export const Task = {
  state: {
    task: {},
    fileCommentList: []
  },
  mutations: {
    setFileCommentList (state, payload) {
      state.fileCommentList = payload.fileCommentList
    },
    updateFileCommentList (state, payload) {
      state.fileCommentList = _.assign(state.fileCommentList, payload.fileCommentList)
    },
    toggleFileCommentListActive (state, payload) {
      state.fileCommentList = _.forEach(state.fileCommentList, comment => {
        if (comment.id !== payload.currentComment.id) {
          comment.activeComment = false
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Task.js